/* Printify PocketPrint — cycles caption lines over a looping video */
(function () {
  'use strict';

  function init(root) {
    var caps = (root || document).querySelectorAll('[data-pf-cap]:not([data-pf-cap-on])');

    caps.forEach(function (el) {
      el.setAttribute('data-pf-cap-on', '1');

      var lines = el.querySelectorAll('b');
      if (!lines.length) return;

      lines[0].classList.add('is-on');
      if (lines.length === 1) return;

      var every = parseFloat(el.getAttribute('data-pf-every') || '3') * 1000;
      if (!every || every < 800) every = 3000;

      var i = 0;
      setInterval(function () {
        lines[i].classList.remove('is-on');
        i = (i + 1) % lines.length;
        lines[i].classList.add('is-on');
      }, every);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
